import { Box } from '@mui/material';
import { Drawer, drawerType } from '../../../../../packages/ui/organisms/drawer';
import {
  btnType,
  Button,
  fontWeight,
  Heading,
  headingLevel,
  IconButton,
  Input,
  inputSize,
  inputType,
  positionType,
  Text,
  TextError,
  Toggle,
} from '../../../../../packages';
import { useFormik } from 'formik';
import { sx } from './GoalDrawer.styles';
import React from 'react';
import dayjs from 'dayjs';
import DatePickerInput from '../../../../admin/claim-detail/components/DatePicker';
import { GLOBAL_DATE_FORMAT } from '../../../../../constants/CommonConstants';
import { ProfileInfoRole } from '../../../../../components/v2/ProfileInfo';

export const EditTreatmentPlanDrawer = ({
  isOpen,
  onClose,
  treatmentPlan,
  onSubmit,
  practitionerDesignation,
}) => {
  const { errors, values, handleChange, handleSubmit, touched, setFieldValue, ...rest } = useFormik({
    initialValues: {
      name: treatmentPlan?.name || '',
      description: treatmentPlan?.description || '',
      expiryDate: dayjs(treatmentPlan?.expiryDate).format(GLOBAL_DATE_FORMAT) || '',
      frequencyOfWorkOutsideSessions: treatmentPlan?.frequencyOfWorkOutsideSessions || '',
      patientInvolved: treatmentPlan?.patientInvolvementInTreatmentPlan?.involved || false,
      patientInvolvedDetails: treatmentPlan?.patientInvolvementInTreatmentPlan?.details || '',
    },
    onSubmit: values => {
      const result = {
        ...treatmentPlan,
        name: values.name,
        description: values.description,
        expiryDate: dayjs(values.expiryDate, GLOBAL_DATE_FORMAT).toISOString(),
        frequencyOfWorkOutsideSessions: values.frequencyOfWorkOutsideSessions,
        patientInvolvementInTreatmentPlan: {
          involved: values.patientInvolved,
          details: values.patientInvolvedDetails,
        },
      };

      onSubmit(result);
      onClose();
    },
  });

  const onChangeExpiry = date => {
    console.log('Onchange');
    if (date?.isValid()) {
      setFieldValue('expiryDate', date.format(GLOBAL_DATE_FORMAT));
    } else {
      setFieldValue('expiryDate', '');
    }
  };

  return (
    <Drawer open={isOpen} onClose={onClose} variant={drawerType.NORMAL} sx={sx.drawer}>
      <Box sx={sx.wrapper}>
        <Box sx={sx.header}>
          <Text sx={sx.headerTitle}>Treatment Plan</Text>
          <IconButton icon="close" onClick={onClose} sx={sx.backBtn} />
        </Box>
        <Box sx={sx.form}>
          <form onSubmit={handleSubmit}>
            <Box sx={sx.formContent}>
              <Box sx={sx.section}>
                <Box flexDirection="column" display="flex" gap="8px">
                  <Box sx={sx.sectionTitle}>Plan Name</Box>
                  <Input
                    value={values.name}
                    name="name"
                    onChange={handleChange}
                    variant={inputType.DEFAULT}
                    size={inputSize.M}
                    fullWidth
                    placeholder="Plan name"
                    sx={sx.valuesInput}
                  />
                  <TextError errorMsg={touched.name ? errors.name?.toString() : null} />
                  <Box sx={sx.sectionTitle}>Plan Description</Box>
                  <Input
                    value={values.description}
                    name="description"
                    onChange={handleChange}
                    variant={inputType.DEFAULT}
                    size={inputSize.M}
                    fullWidth
                    multiline
                    rows={4}
                    placeholder="Treatment Plan Description"
                    sx={sx.valuesInput}
                  />
                  <TextError errorMsg={touched.details ? errors.details?.toString() : null} />
                  <Box sx={sx.sectionTitle}>Expires on</Box>
                  <DatePickerInput
                    date={dayjs(values.expiryDate)}
                    onChange={onChangeExpiry}
                    disableFuture={false}
                  />
                  <TextError errorMsg={touched.expiryDate ? errors.expiryDate?.toString() : null} />
                  <Box sx={sx.sectionTitle}>Frequency of Work Outside Sessions</Box>
                  <Input
                    value={values.frequencyOfWorkOutsideSessions}
                    name="frequencyOfWorkOutsideSessions"
                    onChange={handleChange}
                    variant={inputType.DEFAULT}
                    size={inputSize.M}
                    fullWidth
                    placeholder="Frequency of Work Outside Sessions"
                    sx={sx.valuesInput}
                  />
                  <TextError
                    errorMsg={
                      touched.frequencyOfWorkOutsideSessions
                        ? errors.frequencyOfWorkOutsideSessions?.toString()
                        : null
                    }
                  />
                  <Box sx={sx.sectionTitle}>Patient Involvement in Treatment Plan</Box>
                  <Toggle
                    checked={values.patientInvolved}
                    labelPosition={positionType.RIGHT}
                    onChange={checked => {
                      setFieldValue('patientInvolved', checked);
                    }}
                  >
                    Involved
                  </Toggle>
                  {!values.patientInvolved && (
                    <>
                      <Box sx={sx.sectionTitle}>Why Patient is not involved</Box>
                      <Input
                        value={values.patientInvolvedDetails}
                        name="patientInvolvedDetails"
                        onChange={handleChange}
                        variant={inputType.DEFAULT}
                        size={inputSize.M}
                        fullWidth
                        multiline
                        rows={4}
                        placeholder="Patient Involvement Details"
                        sx={sx.valuesInput}
                      />
                    </>
                  )}
                </Box>
              </Box>
            </Box>
            <Box sx={sx.footer}>
              <Button variant={btnType.TEXT} onClick={onClose}>
                Cancel
              </Button>
              <Button type="submit">Save</Button>
            </Box>
          </form>
        </Box>
      </Box>
    </Drawer>
  );
};
